
import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import FaqSection from './FAQKeyword';
import FleetHighway from './FleetHighway';
import ContactShowcase from './phoneToWhatsApp';
import TestimonialSectionKeyword from './TestimonialSectionKeyword';

function Punetaxihire() {



    const cardData =
    {
        keyword: 'Pune Taxi Hire',
        heading: 'Platinum24 Cabs: Pune Taxi Hire',
        headingDescription: 'Platinum24 Cabs offers dependable Pune Taxi Hire services for both local city rides and long-distance journeys. Whether you need a quick daily commute, airport pickup, business transfer, or an outstation trip, our fleet of hatchbacks, sedans, SUVs, and luxury taxis provides comfort and flexibility for every traveler. With courteous drivers, well-maintained vehicles, and transparent fare options, we make your travel smooth and stress-free. From solo passengers to family groups, Platinum24 Cabs ensures safe, punctual, and affordable taxi hire services across Pune and beyond.',

        top: 'Top Places to Visit in Pune with Platinum24 Cabs',

        "topPlaces": [
  {
    "title": "Shaniwar Wada",
    "description": "Built in 1732 by the Peshwas, Shaniwar Wada is Pune’s most iconic fort palace and a proud symbol of Maratha heritage. Its massive gates, fountains, and courtyards echo tales of the Maratha Empire. Though partially destroyed by fire in 1828, it still attracts thousands of tourists daily. The light-and-sound show narrates the story of Bajirao and Mastani. Visitors enjoy exploring its ruins and lush gardens. Shaniwar Wada is Pune’s cultural crown jewel."
  },
  {
    "title": "Aga Khan Palace",
    "description": "The Aga Khan Palace, built in 1892, is an important landmark in India’s freedom struggle. Mahatma Gandhi, Kasturba Gandhi, and other leaders were imprisoned here during the Quit India Movement. Today, it houses a museum displaying Gandhi’s personal belongings and photographs. The palace’s Italian arches and sprawling gardens make it a peaceful retreat. Tourists admire both its historic and architectural significance. Aga Khan Palace is Pune’s proud heritage of patriotism."
  },
  {
    "title": "Sinhagad Fort",
    "description": "Sinhagad Fort, located 25 km from Pune, is a hill fortress famous for the 1670 battle where Tanaji Malusare fought for Chhatrapati Shivaji Maharaj. Trekkers climb the rugged paths for panoramic views of the Sahyadri ranges. The fort’s gates, bastions, and temples narrate stories of bravery. Monsoon brings mist, greenery, and waterfalls, making it especially scenic. Local vendors serve traditional pithla-bhakri at the top. Sinhagad Fort is Pune’s perfect blend of history and adventure."
  },
  {
    "title": "Dagdusheth Halwai Ganpati Temple",
    "description": "The Shreemant Dagdusheth Halwai Ganpati Temple is Pune’s most revered shrine dedicated to Lord Ganesha. Established over 125 years ago, the grand idol adorned with gold ornaments is a divine sight. During Ganesh Chaturthi, the temple becomes the epicenter of celebrations, attracting lakhs of devotees. The temple is also known for its charitable and cultural initiatives. Its spiritual aura makes it a must-visit for pilgrims and tourists. Dagdusheth is Pune’s divine cultural heart."
  },
  {
    "title": "Pataleshwar Cave Temple",
    "description": "Pataleshwar Cave Temple, carved in the 8th century, is a rock-cut shrine dedicated to Lord Shiva. Its massive stone pillars, sanctum, and Nandi mandapa showcase ancient Indian craftsmanship. Located in the heart of the city, it offers peace and spiritual calm amidst urban chaos. Evening prayers add to its mystical atmosphere. History enthusiasts admire its simple yet powerful design. Pataleshwar is Pune’s hidden gem of spirituality and heritage."
  },
  {
    "title": "Raja Dinkar Kelkar Museum",
    "description": "The Raja Dinkar Kelkar Museum is a cultural treasure housing over 20,000 artifacts collected by Dr. Dinkar Kelkar. It includes ornaments, sculptures, musical instruments, and household antiques. A highlight is the recreated Mastani Mahal, reflecting the Maratha era’s grandeur. Students and art lovers find it educational and fascinating. The museum preserves India’s traditions under one roof. It is Pune’s proud showcase of history and culture."
  },
  {
    "title": "Parvati Hill and Temple",
    "description": "Parvati Hill, one of Pune’s oldest landmarks, offers panoramic views of the city. The hilltop temple complex, built by the Peshwas, is dedicated to Lord Shiva and Goddess Parvati. Smaller shrines and a museum add to its heritage significance. Visitors climb 103 steps to reach the temple, combining devotion with scenic charm. Sunrises and sunsets from the top are breathtaking. Parvati Hill is Pune’s sacred and scenic retreat."
  },
  {
    "title": "Osho Ashram",
    "description": "The Osho International Meditation Resort in Koregaon Park is a global center for spirituality and wellness. Spread across lush gardens, it attracts seekers from all over the world. The ashram offers meditation, yoga, and personal growth workshops. Japanese Zen gardens and serene meditation halls enhance the experience. It is both a wellness retreat and a spiritual destination. Osho Ashram is Pune’s international hub of peace and mindfulness."
  },
  {
    "title": "Pu La Deshpande Garden",
    "description": "Pu La Deshpande Garden, inspired by Japan’s Korakuen Garden, is Pune’s largest landscaped park. With flowing streams, stone bridges, and manicured lawns, it is a favorite for families and nature lovers. Seasonal flowers and lush greenery make it picturesque year-round. Families enjoy picnics, photography, and peaceful strolls here. It also symbolizes Indo-Japanese cultural friendship. Pu La Deshpande Garden is Pune’s green paradise of beauty and calm."
  },
  {
    "title": "Khadakwasla Dam",
    "description": "Khadakwasla Dam, built on the Mutha River, is a popular weekend retreat near Pune. It supplies water to the city while offering scenic views of hills and flowing waters. During monsoon, the overflowing dam creates a spectacular sight. Families enjoy roadside snacks like roasted corn and hot tea here. It is also the gateway to Sinhagad Fort treks. Khadakwasla is Pune’s refreshing natural escape for families and travelers alike."
  }
],



        "services": [
    {
      "name": "Pune Airport Taxi Hire",
      "description": "Hire a dependable taxi for Pune Airport transfers with round-the-clock availability and professional service. Whether you're traveling for business or leisure, our fleet of clean, air-conditioned vehicles ensures a smooth and timely airport commute. Enjoy fixed fares, courteous chauffeurs, and real-time tracking for peace of mind during your airport transfers in Pune."
    },
    {
      "name": "Pune Corporate Taxi Hire",
      "description": "Specialized taxi hire service in Pune for corporate clients, offering a fleet of executive vehicles with trained chauffeurs. Ideal for business meetings, employee pickups, client transportation, and airport transfers. We provide timely, discreet, and comfortable travel tailored to your company’s needs with monthly billing and dedicated support."
    },
    {
      "name": "Luxury Taxi Hire Pune",
      "description": "Experience the highest standard of travel with luxury taxi hire services in Pune. Our premium fleet includes high-end sedans and SUVs, equipped with plush interiors, climate control, and professional chauffeurs. Perfect for weddings, VIP transport, corporate events, or when you want to travel in absolute style and comfort."
    },
    {
      "name": "Pune Outstation Taxi Hire",
      "description": "Hire outstation taxis from Pune to any destination across Maharashtra or neighboring states. Our service includes sanitized vehicles, skilled long-distance drivers, and flexible packages for round trips, one-way travel, or multi-city tours. Ideal for vacations, pilgrimages, or business travel beyond city limits."
    },
    {
      "name": "Pune Local Taxi Rentals",
      "description": "Affordable local taxi rental options in Pune available by the hour or day, perfect for city errands, shopping, meetings, and leisure. Choose from hatchbacks, sedans, or SUVs, with transparent pricing, on-time pickups, and flexible rental durations to suit your travel schedule within Pune city."
    },
    {
      "name": "Pune Wedding Taxi Service",
      "description": "Elegant and reliable taxi services for weddings in Pune, including luxury vehicles for the bride and groom, guest transportation, and customized decor if required. Our professional team ensures seamless coordination and punctual pickups, making your big day stress-free and stylish for all attendees."
    },
    {
      "name": "Pune Taxi Hire for Tours",
      "description": "Explore Pune and nearby destinations with our tour-focused taxi hire services. Ideal for sightseeing, weekend getaways, and heritage tours, we offer knowledgeable drivers, customizable itineraries, and comfortable vehicles to make your journey informative, enjoyable, and hassle-free."
    },
    {
      "name": "Economy Taxi Hire Pune",
      "description": "Budget-friendly taxi hire services in Pune for those who want value without sacrificing reliability or safety. Choose from compact and economy cars, perfect for solo travelers, students, and daily commuters looking for economical travel within city or short-distance trips."
    },
    {
      "name": "Pune Taxi Hire for Events",
      "description": "Dedicated taxi hire for events in Pune, including corporate gatherings, conferences, exhibitions, parties, and social functions. We provide a fleet of well-maintained cars and experienced drivers for seamless group coordination and hassle-free guest transportation."
    },
    {
      "name": "Pune 24/7 Taxi Service",
      "description": "Round-the-clock taxi service in Pune offering instant availability, emergency pickups, and advance bookings any time of day or night. Whether it's an early airport run, a late-night party return, or a medical emergency, we are available 24/7 to get you there safely and quickly."
    },
    {
      "name": "Pune Taxi Hire",
      "description": "Comprehensive taxi hire services in Pune for local and outstation travel. Choose from a wide range of vehicle types and hire durations, with courteous drivers and GPS-enabled vehicles ensuring safety, comfort, and punctuality for every ride you take in and around Pune."
    },
    {
      "name": "Pune to Mumbai Airport Cab",
      "description": "Book a reliable cab from Pune to Mumbai Airport with door-to-door service, fixed pricing, and comfortable vehicles. Ideal for both individual travelers and groups, we ensure timely arrivals and ample luggage space for a stress-free airport transfer experience."
    },
    {
      "name": "Pune to Mumbai Cabs",
      "description": "Trusted cab service from Pune to Mumbai with flexible scheduling, experienced drivers, and multiple car options. Whether it’s a one-way or round trip, our service guarantees timely, safe, and relaxed intercity travel for business or leisure."
    },
    {
      "name": "Pune to Mumbai Cheapest Cab",
      "description": "Get the most economical cab rates from Pune to Mumbai without compromising on safety or comfort. We offer transparent pricing, no hidden charges, and clean, well-maintained vehicles that suit budget-conscious travelers looking for value-packed long-distance rides."
    },
    {
      "name": "Pune to Mumbai Cab Service",
      "description": "Efficient and professional cab service connecting Pune and Mumbai, perfect for commuters, airport travelers, or weekend visitors. Our door-to-door pickup, trained drivers, and real-time GPS tracking ensure a seamless travel experience every time."
    },
    {
      "name": "Cab from Pune to Mahabaleshwar",
      "description": "Comfortable cab services from Pune to Mahabaleshwar with scenic routes, experienced drivers, and optional sightseeing stops. Ideal for weekend getaways or romantic retreats, our service includes one-way, round-trip, and multi-day tour options."
    },
    {
      "name": "Taxi From Pune to Mahabaleshwar",
      "description": "Plan your perfect hill station escape with our Pune to Mahabaleshwar taxi service. Clean, spacious cars and knowledgeable drivers ensure a smooth and scenic ride through the Western Ghats, with flexible pickup times and competitive pricing."
    },
    {
      "name": "Book Cab in Pune",
      "description": "Easily book cabs in Pune with instant confirmation, live tracking, and multiple payment options. Whether it’s for short city trips or long-distance travel, our user-friendly booking process and verified drivers ensure a hassle-free ride every time."
    },
    {
      "name": "Pune to Aurangabad Taxi",
      "description": "Hire a taxi from Pune to Aurangabad with experienced drivers and comfortable vehicles suited for long drives. Ideal for business travel or sightseeing trips to Ajanta-Ellora caves, we offer fixed-rate pricing and smooth coordination for a relaxed journey."
    },
    {
      "name": "Pune to Mumbai Cab Booking",
      "description": "Fast and secure cab booking service for Pune to Mumbai routes. Choose from hatchbacks to luxury cars, with fixed pricing, 24/7 availability, and live trip updates for total convenience and peace of mind during your intercity ride."
    },
    {
      "name": "Pune Mumbai Cabs",
      "description": "Affordable and dependable cabs between Pune and Mumbai for one-way or return trips. Whether you need to reach the airport, attend a meeting, or plan a weekend getaway, we provide clean cars, professional drivers, and on-time service."
    },
    {
      "name": "Outstation Car Rental Pune",
      "description": "Flexible outstation car rental service in Pune offering multi-day packages, customizable routes, and a variety of vehicle options. Whether traveling for business, pilgrimage, or leisure, enjoy smooth rides with expert drivers and well-maintained cars."
    },
    {
      "name": "Pune to Mumbai Cab One Way",
      "description": "One-way cab service from Pune to Mumbai with transparent pricing, quick bookings, and door-to-door pickup. Perfect for business professionals, solo travelers, and families looking for convenient and affordable intercity travel."
    }
  ],
  "tableData": [
    ["Pune Airport Taxi Hire", "Pune Corporate Taxi Hire"],
    ["Luxury Taxi Hire Pune", "Pune Outstation Taxi Hire"],
    ["Pune Local Taxi Rentals", "Pune Wedding Taxi Service"],
    ["Pune Taxi Hire for Tours", "Economy Taxi Hire Pune"],
    ["Pune Taxi Hire for Events", "Pune 24/7 Taxi Service"],
    ["Pune Taxi Hire", "Pune to Mumbai Airport Cab"],
    ["Pune to Mumbai Cabs", "Pune to Mumbai Cheapest Cab"],
    ["Pune to Mumbai Cab Service", "Cab from Pune to Mahabaleshwar"],
    ["Taxi From Pune to Mahabaleshwar", "Book Cab in Pune"],
    ["Pune to Aurangabad Taxi", "Pune to Mumbai Cab Booking"],
    ["Pune Mumbai Cabs", "Outstation Car Rental Pune"],
    ["Pune to Mumbai Cab One Way"]
  ],


      "whychoose": [
    {
        "WhyChooseheading": "Affordable and Convenient Pune Taxi Hire",
        "WhyChoosedescription": "Platinum24 Cabs offers cost-effective and hassle-free taxi hire services across Pune for all your travel needs."
    },
    {
        "WhyChooseheading": "Wide Selection of Taxis for Every Occasion",
        "WhyChoosedescription": "Choose from a variety of well-maintained taxis, perfect for solo trips, family outings, or corporate travel in Pune."
    },
    {
        "WhyChooseheading": "Clean and Comfortable Vehicles",
        "WhyChoosedescription": "Our taxis are regularly sanitized and maintained to ensure a comfortable and safe ride every time."
    },
    {
        "WhyChooseheading": "Experienced Drivers with In-Depth Local Knowledge",
        "WhyChoosedescription": "Our professional drivers know Pune's roads well, ensuring timely pickups and smooth travel throughout the city."
    },
    {
        "WhyChooseheading": "Flexible Rental Options to Suit Your Schedule",
        "WhyChoosedescription": "Whether you need a taxi for an hour, a full day, or longer, we tailor packages to fit your Pune travel plans."
    },
    {
        "WhyChooseheading": "Transparent Pricing with No Hidden Fees",
        "WhyChoosedescription": "We provide clear, upfront pricing for all Pune taxi hires, including fuel and tolls, for complete peace of mind."
    },
    {
        "WhyChooseheading": "Ideal for Airport Transfers, Local Sightseeing, and Business Travel",
        "WhyChoosedescription": "Our Pune taxi hire service caters to various needs, from airport rides to city tours and corporate commutes."
    },
    {
        "WhyChooseheading": "24/7 Customer Support for Easy Booking and Assistance",
        "WhyChoosedescription": "Our dedicated team is always available to help with bookings, itinerary changes, and special requests."
    }
]













    }


    const faqData = [
    {
        question: 'Does Platinum24 Cabs offer taxi hire services in Pune?',
        answer: 'Yes, Platinum24 Cabs provides convenient and affordable taxi hire services across Pune for all types of travel needs.',
    },
    {
        question: 'How can I hire a taxi with Platinum24 Cabs in Pune?',
        answer: 'You can hire a taxi easily via our website, mobile app, or by calling our 24/7 customer service helpline.',
    },
    {
        question: 'Are Platinum24 taxis available for outstation travel from Pune?',
        answer: 'Absolutely! We offer outstation taxi hire options for destinations like Mumbai, Lonavala, Shirdi, and more.',
    },
    {
        question: 'What types of taxis are available for hire with Platinum24 Cabs?',
        answer: 'We offer a fleet that includes hatchbacks, sedans, SUVs, and luxury cars to suit solo, family, or group travel.',
    },
    {
        question: 'Can I hire a taxi for a full day in Pune?',
        answer: 'Yes, Platinum24 Cabs offers full-day and half-day taxi rental packages for city tours, business trips, and events.',
    },
    {
        question: 'Are the drivers experienced and verified?',
        answer: 'Yes, all our drivers are background-verified, experienced, and trained to provide a safe and courteous travel experience.',
    },
    {
        question: 'Is it possible to schedule a taxi in advance?',
        answer: 'Yes, you can pre-schedule your taxi hire through our app or website to ensure availability at your preferred time.',
    },
    {
        question: 'Are the taxis sanitized and well-maintained?',
        answer: 'Yes, our taxis are regularly cleaned, sanitized, and undergo routine maintenance checks for safety and hygiene.',
    },
    {
        question: 'Is there customer support for Pune taxi hire bookings?',
        answer: 'Yes, our support team is available around the clock to help with bookings, modifications, and ride support.',
    },
    {
        question: 'Do Platinum24 Cabs provide taxi hire services to corporate clients in Pune?',
        answer: 'Yes, we offer customized taxi hire solutions for corporate travel, including monthly billing and priority support.',
    },
];

const testimonials = [
    {
        id: 1,
        name: 'Mr. Suresh Patil',
        feedback: 'I hired a taxi from Platinum24 Cabs for a business trip in Pune. The car was clean and the driver was very professional.',
        rating: 5,
    },
    {
        id: 2,
        name: 'Mrs. Kavita Naik',
        feedback: 'Platinum24’s taxi hire service was prompt and affordable. It made my shopping day in Pune so much easier!',
        rating: 5,
    },
];




























    const Images = [
        { place: "/images/keyword/1.jpg", text: "Pune Cab Service", link: "pune-cab-service" },
        { place: "/images/keyword/2.jpg", text: "Pune Taxi Hire", link: "pune-taxi-hire" },
        { place: "/images/keyword/3.jpg", text: "Pune Online Cab Booking", link: "pune-online-cab-booking" },
        { place: "/images/keyword/4.jpg", text: "Best Cab Service in Pune", link: "best-cab-service-in-pune" },
        { place: "/images/keyword/5.jpg", text: "Pune to Mumbai Cabs", link: "pune-to-mumbai-cabs" },
        { place: "/images/keyword/6.jpg", text: "Pune to Nashik Cabs", link: "pune-to-nashik-cabs" },
        { place: "/images/keyword/7.jpg", text: "Pune to Mahabaleshwar Cabs", link: "pune-to-mahabaleshwar-cabs" },
        { place: "/images/keyword/8.jpg", text: "Pune to Lonavala Cabs", link: "pune-to-lonavala-cabs" },
        { place: "/images/keyword/9.jpg", text: "Pune to Shirdi Cab", link: "pune-to-shirdi-cab" },
        { place: "/images/keyword/10.jpg", text: "Pune to Bhimashankar Cab", link: "pune-to-bhimashankar-cab" },
        { place: "/images/keyword/11.jpg", text: "Pune to Konkan Darshan Cabs", link: "pune-to-konkan-darshan-cabs" },
        { place: "/images/keyword/12.jpg", text: "Pune Outstation Cabs", link: "pune-outstation-cabs" },
        { place: "/images/keyword/13.jpg", text: "Ashtavinayak Darshan Cab", link: "ashtavinayak-darshan-cab" },
        { place: "/images/keyword/14.jpg", text: "Pune to Goa Cabs", link: "pune-to-goa-cabs" },
        { place: "/images/keyword/15.jpg", text: "Cabs Services Near Me", link: "cabs-services-near-me" },
        { place: "/images/keyword/16.jpg", text: "Corporate Cab Service in Pune", link: "corporate-cab-service-in-pune" },
        { place: "/images/keyword/17.jpg", text: "Pune to Mumbai Airport Cabs", link: "pune-to-mumbai-airport-cabs" },
        { place: "/images/keyword/18.jpg", text: "Tempo Traveller On Rent in Pune", link: "tempo-traveller-on-rent-in-pune" },
        { place: "/images/keyword/19.jpg", text: "Urbania On Rent in Pune", link: "urbania-on-rent-in-pune" },
        { place: "/images/keyword/20.jpg", text: "Innova Crysta On Rent in Pune", link: "innova-crysta-on-rent-in-pune" },
        { place: "/images/keyword/21.jpg", text: "Bus On Rent in Pimpri Chinchwad", link: "bus-on-rent-in-pimpri-chinchwad" },
        { place: "/images/keyword/22.jpg", text: "Mini Bus On Rent in Pune", link: "mini-bus-on-rent-in-pune" },
        { place: "/images/keyword/23.jpg", text: "Ertiga On Rent in Pune", link: "ertiga-on-rent-in-pune" },
        { place: "/images/keyword/24.jpg", text: "Pune to Sambhaji Nagar Taxi", link: "pune-to-sambhaji-nagar-taxi" },
        { place: "/images/keyword/25.jpg", text: "Pune to Ganpatipule Taxi", link: "pune-to-ganpatipule-taxi" }
    ];









const puneTaxiHireSchema = {
  "@context": "https://schema.org",
  "@type": "Product",
  "name": "Pune Taxi Hire",
  "image": "https://www.platinum24cab.com/assets/images/pune-taxi-hire.jpg",
  "description": "Hire taxis in Pune with Platinum24 Cabs – perfect for airport transfers, outstation trips, weddings, corporate events, and more. Choose from luxury, economy, and 24/7 available taxi options.",
  "brand": {
    "@type": "Brand",
    "name": "Platinum24 Cabs"
  },
  "aggregateRating": {
    "@type": "AggregateRating",
    "ratingValue": "4.8",
    "ratingCount": "28420",
    "bestRating": "5",
    "worstRating": "1"
  },
  "offers": {
    "@type": "Offer",
    "priceCurrency": "INR",
    "price": "1100",
    "availability": "https://schema.org/InStock",
    "url": "https://www.platinum24cab.com/pune-taxi-hire"
  }
};





    return (
        <div>


<Helmet>
  <title>Pune Taxi Hire | Book Luxury & Economy Taxis | Platinum24 Cabs</title>
  <meta
    name="description"
    content="Hire taxis in Pune with Platinum24 Cabs – perfect for airport transfers, outstation trips, weddings, corporate events, and more. Choose from luxury, economy, and 24/7 available taxi options."
  />
  <meta
    name="keywords"
    content="Pune Airport Taxi Hire, Pune Corporate Taxi Hire, Luxury Taxi Hire Pune, Pune Outstation Taxi Hire, Pune Local Taxi Rentals, Pune Wedding Taxi Service, Pune Taxi Hire for Tours, Economy Taxi Hire Pune, Pune Taxi Hire for Events, Pune 24/7 Taxi Service, Pune Taxi Hire, Pune to Mumbai Airport Cab, Pune to Mumbai Cabs, Pune to Mumbai Cheapest Cab, Pune to Mumbai Cab Service, Cab from Pune to Mahabaleshwar, Taxi From Pune to Mahabaleshwar, Book Cab in Pune, Pune to Aurangabad Taxi, Pune to Mumbai Cab Booking, Pune Mumbai Cabs, Outstation Car Rental Pune, Pune to Mumbai Cab One Way"
  />
  <script type="application/ld+json">
    {JSON.stringify(puneTaxiHireSchema)}
  </script>
</Helmet>
            <div
                className="breadcumb-wrapper"
                // style={{ backgroundImage: "url('/img/breadcumb/breadcumb-bg.jpg')" }}
            >
                <div className="container z-index-common">
                    <div className="breadcumb-content">
                        <h1 className="breadcumb-title">{cardData.keyword}</h1>
                        <div className="breadcumb-menu-wrap">
                        </div>
                    </div>
                </div>
            </div>










            <section>
                <div className="container-fluid" >
                    <div className="row container-fluid">
                        <div className="col-12 col-md-7 bg-foootr">
                            <img src='/images/keyword/2.jpg' alt='img' />
                            <h3 className="py-1"
                                style={{
                                    color: '#183765', // Red color for the title 
                                    textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                                    fontWeight: 'bold'
                                }}


                            >{cardData.heading} </h3><p className='fw-bold '>{cardData.headingDescription}</p>
                            <div className="topPlaces">
                                <p className="sectionLead">{cardData.top}</p>

                                {cardData.topPlaces.map((place, index) => (
                                    <article key={index} className="placeCard" tabIndex="0">
                                        <span className="placeBadge">{String(index + 1).padStart(2, "0")}</span>

                                        <div className="placeBody">
                                            <h4 className="placeTitle">{place.title}</h4>
                                            <p className="placeDesc">{place.description}</p>
                                        </div>

                                        <span className="placeArrow" aria-hidden>›</span>
                                    </article>
                                ))}
                            </div>
                            <div className="services-section">
                                {cardData.services.map((service, index) => (
                                    <div key={index} className="service-row">
                                        <div className="service-icon">
                                            🚖
                                        </div>
                                        <div>
                                            <h4 className="service-title">{service.name}</h4>
                                            <p className="service-desc">{service.description}</p>
                                        </div>
                                    </div>
                                ))}
                            </div>


                            <table className="table table-responsive Border-key my-2">
                                <tbody className=' Border-key'>
                                    {cardData.tableData.map((row, rowIndex) => (
                                        <tr className='Border-key ' key={rowIndex}>
                                            {row.map((cell, cellIndex) => (
                                                <td key={cellIndex} className=' Border-key bluecolor fw-bold' >{cell}</td>
                                            ))}
                                        </tr>
                                    ))}
                                </tbody>
                            </table>
                            <h3 className='pt-md-3'>{cardData.keyword + " Rates"}</h3>
                            <BusRatesTable />

                            <div id="why-choose-section" className="why-choose-section">


                                {/* Section Title */}
                                <h2 className="section-title">
                                    Why Choose <span>Platinum24 Cabs</span>
                                </h2>

                                {/* Cards */}
                                <div className="cards-grid">
                                    {cardData.whychoose.map((item, index) => (
                                        <div key={index} className="why-card">
                                            <div className="icon-circle">{index + 1}</div>
                                            <h4 className="card-heading">{item.WhyChooseheading}</h4>
                                            <p className="card-desc">{item.WhyChoosedescription}</p>
                                        </div>
                                    ))}
                                </div>
                            </div>



                            <div className="row twm-faq-section-1 m-b30">


                                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                                    <div className="twm-faq-info-wrap">

                                        <div className="section-head left">
                                            <h2 className="twm-large-title site-text-dark">FAQS {cardData.keyword} For Platinum24 Cabs </h2>
                                        </div>


                                        <div className="twm-faq-info">
                                            <div className="accordion twm-acdn" id="sf-faq-accordion">

                                                <FaqSection
                                                    title="Frequently Asked"
                                                    subtitle="Help & Info"
                                                    items={faqData}
                                                />

                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <TestimonialSectionKeyword
                                testimonials={testimonials}
                            />


                            <ContactShowcase />
                        </div>

                        <div className='col-12 col-md-4' >
                            <div className="routeList">
                                {Images.map((e, i) => {
                                    const isExternal = typeof e.link === "string" && /^https?:\/\//i.test(e.link);
                                    const href = isExternal ? e.link : `/${String(e.link || "").replace(/^\/+/, "")}`;

                                    return (
                                        <a
                                            key={e.link || i}
                                            href={href}
                                            className="routeItem"
                                            aria-label={e.text}
                                            {...(isExternal ? { target: "_blank", rel: "noopener noreferrer" } : {})}
                                        >
                                            <div className="routeThumb">
                                                <img src={e.place} alt="" loading="lazy" />
                                            </div>

                                            <div className="routeMeta">
                                                <h6 className="routeTitle">{e.text}</h6>
                                                <span className="routeUnderline" />
                                            </div>

                                            <span className="routeArrow" aria-hidden>›</span>
                                        </a>
                                    );
                                })}
                            </div>




                            <div>
                                <FleetHighway />
                            </div>
                            <div className="pc-contact">
                                <h4 className="pc-title">Contact Information</h4>

                                <div className="pc-grid">
                                    {/* Phones */}
                                    <section className="pc-tile">
                                        <header className="pc-tile-head">
                                            <i className="bi bi-telephone-fill"></i>
                                            <span>Phone Numbers</span>
                                        </header>

                                        <div className="pc-list">
                                            <a href="tel:+917507048333" className="pc-call">+91 7507048333</a>
                                        </div>

                                        <div className="pc-cta">
                                            <a
                                                href="https://wa.me/917507048333"
                                                target="_blank" rel="noopener noreferrer"
                                                className="pc-whats"
                                            >
                                                <i className="bi bi-whatsapp me-1"></i> WhatsApp
                                            </a>
                                            <a href="tel:+917507048333" className="pc-primary">
                                                Call Now
                                            </a>
                                        </div>
                                    </section>

                                    {/* Email */}
                                    <section className="pc-tile">
                                        <header className="pc-tile-head">
                                            <i className="bi bi-envelope-fill"></i>
                                            <span>Email</span>
                                        </header>

                                        <a href="mailto:booking@platinum24cab.com" className="pc-email">
                                            booking@platinum24cab.com
                                        </a>
                                    </section>

                                    {/* Address */}
                                    <section className="pc-tile">
                                        <header className="pc-tile-head">
                                            <i className="bi bi-house-fill"></i>
                                            <span>Address</span>
                                        </header>

                                        <address className="pc-address">
                                            <strong>Platinum24 Cabs</strong><br />
                                            OFFICE NO.2, SECTOR NO.4, PLOT NO.295(S), SAI GANGA APARTMENT, ABOVE UMED ELECTRICAL, NEAR ACORD HOSPITAL
                                            FIRST FLOOR, SANT NAGAR, MOSHI, PUNE 412105
                                        </address>
                                    </section>
                                </div>
                            </div>


                        </div>
                    </div>
                </div>
            </section>


        </div>
    );
}

export default Punetaxihire;